import {gql, useLazyQuery} from '@apollo/client';
import {useAuth} from '@saltus/auth';
import {useEffect} from 'react';
import {GetLoginInfo, GetLoginInfoVariables} from '../schema-types/GetLoginInfo';
import {NOTIFICATION_FRAGMENT} from '../graphql/fragments';

export const LOGGED_IN_USER_FRAGMENT = gql`
  fragment LoggedInUser on StaffType {
    id
    email
    name
    curoId
    isAdviser
    isAdministrator
    isServiceManager
    isSupervisor
    isParaplanner
    isCaseChecker
    isDeleted
    isUserDev
    isUserTester
    isUserPowerUser
    isGod
    isSam
    isPad
    permissionOverride
    groups {
      id
      name
    }
    perms {
      id
      codename
      name
    }
    userPerms {
      id
      codename
      name
    }
    groupPerms {
      id
      codename
      name
    }
    businessUnit {
      id
      name
      partnershipType
      divisionName
    }
  }
`;

export const GET_LOGIN_INFO_QUERY = gql`
  query GetLoginInfo($adviserId: UUID!, $getMobile: Boolean!) {
    adviserMobileNumber(adviserId: $adviserId) @include(if: $getMobile)
    getCurrentUser {
      ...LoggedInUser
    }
    notifications {
      ...NotificationFragment
    }
  }
  ${NOTIFICATION_FRAGMENT}
  ${LOGGED_IN_USER_FRAGMENT}
`;

function useDjango() {
  const {user} = useAuth();

  const [GetAdviserEmail, {data, error, loading}] = useLazyQuery<
    GetLoginInfo,
    GetLoginInfoVariables
  >(GET_LOGIN_INFO_QUERY);

  useEffect(() => {
    if (user?.attributes) {
      GetAdviserEmail({
        variables: {
          adviserId: user.attributes.sub,
          getMobile: process.env.NODE_ENV !== 'development',
        },
      });
    }
  }, [user?.attributes.sub]);

  return {
    djangoUser: data?.getCurrentUser || null,
    notifications: data?.notifications,
    error,
    loading,
  };
}

export default useDjango;
